import Vue from 'vue';
import GenericExtensionFormatting from './menu-items/GenericExtensionFormatting.vue';

import { RICH_TEXT_MENU_BUTTONS, HTML_MENU_BUTTONS_KEYS, MARKDOWN_MENU_BUTTONS_KEYS, TEXT_MENU_BUTTONS_KEYS } from './rich-text-menu.const';
import { TEXT_BOX_FORMAT_TYPES } from '../rich-text-box.const';

// Private

// filtered by feature flag
const getTextMenuButtonsKeys = (isConfigurationsOn) => (isConfigurationsOn ? TEXT_MENU_BUTTONS_KEYS : []);

// Public

const fromExtentionToSimpleMenuItemHOF = (ButtonSvg, isActiveString, toggleFunc) => {
	const originalProps = GenericExtensionFormatting.props || {};
	const originalComponents = GenericExtensionFormatting.components || {};

	return Vue.component('withSimpleMenuItems', {
		render(createElement) {
			return createElement(GenericExtensionFormatting, {
				components: {
					...originalComponents,
				},
				props: {
					ButtonSvg,
					editor: this.editor,
					isActiveString,
					toggleFunc,
				},
			});
		},
		props: { ...originalProps },
		// data() {
		// 	return {
		// 		fetchedData: null,
		// 	};
		// },
		// methods: {
		// 	handleChange() {
		// 		this.fetchedData = selectData(DataSource, this.$props);
		// 	},
		// },
		// mounted() {
		// 	DataSource.addChangeListener(this.handleChange);
		// },
		// beforeDestroy() {
		// 	DataSource.removeChangeListener(this.handleChange);
		// },
	});
};

const getMenuItems = (richTextFormat, isConfigurationsOn) => {
	const menuItemKeys = [...getTextMenuButtonsKeys(isConfigurationsOn)];
	if ([TEXT_BOX_FORMAT_TYPES.HTML, TEXT_BOX_FORMAT_TYPES.MARKDOWN].includes(richTextFormat)) {
		menuItemKeys.unshift(...HTML_MENU_BUTTONS_KEYS);
		if (TEXT_BOX_FORMAT_TYPES.HTML === richTextFormat) {
			menuItemKeys.unshift(...MARKDOWN_MENU_BUTTONS_KEYS);
		}
	}
	return menuItemKeys.map((key) => ({ key, ...RICH_TEXT_MENU_BUTTONS[key] }));
};

const RichTextMenuService = {
	fromExtentionToSimpleMenuItemHOF,
	getMenuItems,
};

export default RichTextMenuService;
